import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';
import styles from './index.css';
import Text from './Text';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';

dayjs.extend(duration);

const formatTime = timestamp => {
    const target = dayjs.unix(timestamp);
    const now = dayjs();
    const min1Before = now.subtract(1, 'minute');
    const hour1Before = now.subtract(1, 'hour');
    const hour24Before = now.subtract(24, 'hour');
    const hour48Before = now.subtract(48, 'hour');
    const hour72Before = now.subtract(72, 'hour');

    const targetMs = target.valueOf();
    const nowMs = now.valueOf();
    const min1BeforeMs = min1Before.valueOf();
    const hour1BeforeMs = hour1Before.valueOf();
    const hour24BeforeMs = hour24Before.valueOf();
    const hour48BeforeMs = hour48Before.valueOf();
    const hour72BeforeMs = hour72Before.valueOf();

    if (targetMs >= min1BeforeMs) {
        return '刚刚';
    } else if (targetMs >= hour1BeforeMs) {
        return `${dayjs.duration(nowMs - targetMs).minutes()}分钟前`;
    } else if (targetMs >= hour24BeforeMs) {
        return `${dayjs.duration(nowMs - targetMs).hours()}小时前`;
    } else if (targetMs >= hour48BeforeMs) {
        return '1天前';
    } else if (targetMs >= hour72BeforeMs) {
        return '2天前';
    } else {
        return target.format('YYYY-MM-DD');
    }
};

const Comment = ({ content }) => {
    const { children, comment_contents, create_time, faceurl, uname, ip_from, pid, isVideoShare, uptimes } = content;

    const handleLikeClick = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const downloads = isVideoShare
            ? {}
            : {
                  download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1525891435397',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8977',
              };
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        if (isCallApp) {
            callApp({
                client,
                docType: 'phvideo',
                pid,
                kind: 'inter_fxy15',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
                noKindFrom: 1,
            });
        }
    };

    const handleReplyClick = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const downloads = isVideoShare
            ? {}
            : {
                  download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1525891435402',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8978',
              };
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        if (isCallApp) {
            callApp({
                client,
                docType: 'phvideo',
                pid,
                kind: 'inter_fxy16',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
                noKindFrom: 1,
            });
        }
    };

    const handleMoreClick = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const downloads = isVideoShare
            ? {}
            : {
                  download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1525891435404',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8980',
              };
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        if (isCallApp) {
            callApp({
                client,
                docType: 'phvideo',
                pid,
                kind: 'inter_fxy18',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
                noKindFrom: 1,
            });
        }
    };

    const schemeLinkLike = getSchemeLink({
        docType: 'phvideo',
        pid,
        kind: 'inter_fxy15',
        noKindFrom: 1,
    });

    const schemeLinkReply = getSchemeLink({
        docType: 'phvideo',
        pid,
        kind: 'inter_fxy16',
        noKindFrom: 1,
    });

    const schemeLinkMore = getSchemeLink({
        docType: 'phvideo',
        pid,
        kind: 'inter_fxy18',
        noKindFrom: 1,
    });

    return (
        <div className={styles.wrap}>
            <div className={styles.left}>
                <div className={styles.avatar}>
                    <img src={formatImage(faceurl, 64, 64)} alt="" />
                </div>
            </div>
            <div className={styles.right}>
                <div className={styles.nav}>
                    <div className={styles.uname}>{uname}</div>
                    <div className={styles.like} onClick={handleLikeClick}>
                        {!isVideoShare && (
                            <WxLaunchApp
                                launchType={'app'}
                                launchAppClick={() => {
                                    handleLikeClick(true, false, false);
                                }}
                                schemeLink={schemeLinkLike}
                                launchAppFail={() => {
                                    handleLikeClick(false, true, true);
                                }}
                            />
                        )}
                        {uptimes > 0 ? <div className={styles.likeText}>{uptimes}</div> : null}
                        <div className={styles.likeIcon} />
                    </div>
                </div>
                <Text
                    content={{
                        comment_contents,
                        wrapClass: styles.text,
                        addonClass: styles.addon,
                        pid,
                        isVideoShare,
                    }}
                />
                <div className={styles.info}>
                    <div className={styles.location}>{ip_from}</div>
                    <div className={styles.time}>{formatTime(create_time)}</div>
                    <div className={styles.separate} />
                    <div className={styles.reply} onClick={handleReplyClick}>
                        {!isVideoShare && (
                            <WxLaunchApp
                                launchType={'app'}
                                launchAppClick={() => {
                                    handleReplyClick(true, false, false);
                                }}
                                schemeLink={schemeLinkReply}
                                launchAppFail={() => {
                                    handleReplyClick(false, true, true);
                                }}
                            />
                        )}
                        回复
                    </div>
                </div>
                {children && children.count ? (
                    <div className={styles.children}>
                        <div className={styles.childrenList}>
                            {children.comments && children.comments.length
                                ? children.comments.map((item, index, arr) => {
                                      const {
                                          comment_id,
                                          comment_contents,
                                          create_time,
                                          faceurl,
                                          uname,
                                          ip_from,
                                          uptimes,
                                      } = item;

                                      return (
                                          <div className={styles.childrenItem} key={comment_id}>
                                              <div className={styles.left}>
                                                  <div className={styles.avatar}>
                                                      <img src={formatImage(faceurl, 48, 48)} alt="" />
                                                  </div>
                                              </div>
                                              <div className={styles.right}>
                                                  <div className={styles.nav}>
                                                      <div className={styles.uname}>{uname}</div>
                                                      <div className={styles.like} onClick={handleLikeClick}>
                                                          {!isVideoShare && (
                                                              <WxLaunchApp
                                                                  launchType={'app'}
                                                                  launchAppClick={() => {
                                                                      handleLikeClick(true, false, false);
                                                                  }}
                                                                  schemeLink={schemeLinkLike}
                                                                  launchAppFail={() => {
                                                                      handleLikeClick(false, true, true);
                                                                  }}
                                                              />
                                                          )}
                                                          {uptimes > 0 ? (
                                                              <div className={styles.likeText}>{uptimes}</div>
                                                          ) : null}
                                                          <div className={styles.likeIcon} />
                                                      </div>
                                                  </div>
                                                  <Text
                                                      content={{
                                                          comment_contents,
                                                          wrapClass: styles.text,
                                                          addonClass: styles.addon,
                                                          pid,
                                                          isVideoShare,
                                                      }}
                                                  />
                                                  <div className={styles.info}>
                                                      <div className={styles.location}>{ip_from}</div>
                                                      <div className={styles.time}>{formatTime(create_time)}</div>
                                                      <div className={styles.separate} />
                                                      <div className={styles.reply} onClick={handleReplyClick}>
                                                          {!isVideoShare && (
                                                              <WxLaunchApp
                                                                  launchType={'app'}
                                                                  launchAppClick={() => {
                                                                      handleReplyClick(true, false, false);
                                                                  }}
                                                                  schemeLink={schemeLinkReply}
                                                                  launchAppFail={() => {
                                                                      handleReplyClick(false, true, true);
                                                                  }}
                                                              />
                                                          )}
                                                          回复
                                                      </div>
                                                  </div>
                                                  {children.count > 2 && index === arr.length - 1 ? (
                                                      <div className={styles.childrenMore} onClick={handleMoreClick}>
                                                          {!isVideoShare && (
                                                              <WxLaunchApp
                                                                  launchType={'app'}
                                                                  launchAppClick={() => {
                                                                      handleMoreClick(true, false, false);
                                                                  }}
                                                                  schemeLink={schemeLinkMore}
                                                                  launchAppFail={() => {
                                                                      handleMoreClick(false, true, true);
                                                                  }}
                                                              />
                                                          )}
                                                          <div className={styles.childrenMoreText}>
                                                              查看全部{children.count}条
                                                          </div>
                                                          <div className={styles.childrenMoreArrow} />
                                                      </div>
                                                  ) : null}
                                              </div>
                                          </div>
                                      );
                                  })
                                : null}
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

Comment.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Comment);
